import { Form, Input } from "antd";
import { FORMDATA } from "constants/Data";
import { FC, useState } from "react";
import { useDispatch } from "react-redux";
import { AppDispatch } from "redux/store";
import { toastText } from "utils/utils";
import { addRoleActionTable, cloneRoleActionTable, editRoleActionTable } from "../../../../redux/actions/roleTableAction";
import styles from "./index.module.scss";
import "./index.scss";
import { SideDrawerBodyProps } from "./types";


const AddRoleBody: FC<SideDrawerBodyProps> = (props) => {
  const {
    closeDrawerByAnimation,
    editSelectedRole,
    copyrole,
    fetchRoles
  } = props;
  const { addRoleFields } = FORMDATA;
  const [form] = Form.useForm();
  const [saveAndAddLoader, setSaveAndAddLoader] = useState(false);

  const dispatch = useDispatch<AppDispatch>();

  // If form gets successfully submitted
  const onFinish = (values: any, buttonType = "save") => {
    const trimmedRoleName = (values?.roleName || "").trim();
    const trimmedRoleDescription = (values?.roleDescription || "").trim();

  
    // Assign the trimmed values back to values
    values.roleName = trimmedRoleName;
    values.roleDescription = trimmedRoleDescription;

    if (editSelectedRole) {
      if (!copyrole) {
        const data = {
          roleId: editSelectedRole?.id,
          roleName: values?.roleName,
          roleDescription: values?.roleDescription,
        };
        dispatch(editRoleActionTable(data)).then((res: any) => {
          if (res?.payload?.response?.responseStatus === 200) {
            toastText(res?.payload?.response?.message, 'success');
          } else {
            toastText(res?.payload?.message, 'error');
          }
        }).finally(() => {
          fetchRoles();
          closeDrawerByAnimation();
        });
      }
      else {
        const data = {
          cloneRoleId: editSelectedRole?.id,
          roleName: values?.roleName,
          roleDescription: values?.roleDescription
        };
        dispatch(cloneRoleActionTable(data)).then((res: any) => {
          if (res?.payload?.response?.responseStatus === 200) {
            toastText(res?.payload?.response?.message, 'success');
          } else {
            toastText(res?.payload?.message, 'error');

          }
        }).finally(() => {
          fetchRoles();
          closeDrawerByAnimation();
          form.resetFields();
        });
      }
    } else {
      if (buttonType === "SaveAndAdd") {
        setSaveAndAddLoader(true);
      }
      dispatch(addRoleActionTable(values))
        .then((res: any) => {
          const isSaveAndAdd = buttonType === "SaveAndAdd";
          const isSuccess = res?.payload?.responseStatus === 200;
          if (isSaveAndAdd && isSuccess) {
            form.resetFields();
            closeDrawerByAnimation();
          }

          if (isSuccess) {
            toastText(res?.payload?.message, 'success');
          }
          else {
            toastText(res?.payload?.message, 'error');
          }

        }).finally(async () => {
          fetchRoles();
          setSaveAndAddLoader(false);
          form.resetFields();
        });
    }
  };

  // Handle 'Save and Add' button click
  const saveAndAdd = () => {
    const formValues = form.getFieldsValue();
    form.validateFields();
    if (formValues?.roleName && formValues?.roleDescription)
      onFinish(formValues, "SaveAndAdd");
  };

  // If form submission fails
  const onFinishFailed = (errorInfo: any) => {
    console.log("Failed:", errorInfo);
  };

  return (
    <div className={styles["side-drawer-body"]}>
      <Form
        form={form}
        name="basic"
        initialValues={editSelectedRole}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        autoComplete="off"
        layout="vertical"
        labelAlign="left"
        className={styles["side-drawer-form"]}
      >
        <div className={styles["side-drawer-form__inputs"]}>
          {addRoleFields.map((singleField, index) => {
            return (
              <div
                key={index}
                className={styles["side-drawer-form__single-input"]}
              >
                <label
                  className={styles["side-drawer-form__single-input--label"]}
                >
                  {singleField?.title}{" "}
                  {singleField?.required && (
                    <span className="required-color">*</span>
                  )}
                </label>
                {singleField.type === "textArea" ? (
                  <Form.Item
                    name={singleField.name}
                    className={`${styles["side-drawer-form__single-input--input"]} text-area-error`}
                    rules={singleField.rules as []}
                  >
                    <textarea
                      className={
                        styles["side-drawer-form__single-input--textarea"]
                      }
                      placeholder={singleField.placeholder}
                    />
                  </Form.Item>
                ) : (
                  <Form.Item
                    name={singleField.name}
                    className={styles["side-drawer-form__single-input--input"]}
                    rules={singleField.rules as []}
                  >
                    <Input
                      placeholder={singleField.placeholder}
                      size="large"
                      type={singleField.type}
                    />
                  </Form.Item>
                )}
              </div>
            );
          })}
        </div>
        <div className={styles["side-drawer-form__buttons"]}>
          <Form.Item>
            <button
              type="button"
              className={`${styles["side-drawer-form__buttons__save-and-add"]} ${saveAndAddLoader && `pointer-event-none ${styles["loader"]}`
                }`}
              onClick={saveAndAdd}
            >
              {saveAndAddLoader ? (
                <img
                  src={`/assets/gifs/loading-black.gif`}
                  crossOrigin={
                    process.env.REACT_APP_ENV === "local"
                      ? undefined
                      : "anonymous"
                  }
                  alt="loader"
                  height={40}
                />
              ) : (
                "Save"
              )}
            </button>
          </Form.Item>

          <Form.Item>
            <button
              type="button"
              className={styles["side-drawer-form__buttons--cancel"]}
              onClick={() => {
                closeDrawerByAnimation();
              }}
            >
              Cancel
            </button>
          </Form.Item>
        </div>
      </Form>
    </div>
  );
};

export default AddRoleBody;
